import styled from "styled-components/macro";
import { ContainerLogin } from "components/containers";
import { Button } from "components/generic";

export const StyledContainer = styled(ContainerLogin)`
  @media (max-width: 500px) {
    padding-top: 1.5rem;
  }
`;

export const StyledAuthButton = styled(Button)`
  &:hover {
    background: #d7520a;
    color: white;
  }
  &:active:not(:disabled) {
    color: white;
  }
`;

export const TextLink = styled.p`
  color: ${({ theme }) => theme.colors.thirdly};
  font-weight: 600;
  cursor: pointer;
`;
